exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._31-zdHVLjyD_NyxZtEdYEo{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._1pLDmhG1YrboX3xZjaEoEY{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;white-space:nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}html[dir=ltr] ._1pLDmhG1YrboX3xZjaEoEY:first-of-type{margin-right:5px}html[dir=ltr] ._1pLDmhG1YrboX3xZjaEoEY:last-of-type,html[dir=rtl] ._1pLDmhG1YrboX3xZjaEoEY:first-of-type{margin-left:5px}html[dir=rtl] ._1pLDmhG1YrboX3xZjaEoEY:last-of-type{margin-right:5px}", ""]);

// exports
exports.locals = {
	"buttonContainer": "_31-zdHVLjyD_NyxZtEdYEo",
	"button": "_1pLDmhG1YrboX3xZjaEoEY"
};